import { render, staticRenderFns } from "./HeaderNavbar.vue?vue&type=template&id=dc133898&scoped=true&"
var script = {}
import style0 from "./HeaderNavbar.vue?vue&type=style&index=0&id=dc133898&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc133898",
  null
  
)

export default component.exports